var render = function render(){var _vm=this,_c=_vm._self._c;return _c('em',{staticClass:"fluid-xs leading-tightest not-italic my-3 inline-block font-medium"},[_vm._v(_vm._s(_vm.$t(_vm.isVideo ? 'watchTime' : 'readTime', { min: _vm.readTime })))])
}
var staticRenderFns = []

export { render, staticRenderFns }